export const resetPrevPolygon = (
        siteSetupState,
        isSiteAreaPolygon,
        isHoleeAreaPolygon,
        TempSiteData,
        siteAreaClickEventData, 
        siteAreaClickEvent,
        indexId,
        mapData,
        mapsData,
        teesAreaPathState,
        teesPathCoordsState,
        fwysAreaPathState,
        fwysPathCoordsState,
        gmsAreaPathState,
        gmsPathCoordsState,
        extsAreaPathState,
        extsPathCoordsState,
        stgsAreaPathState,
        stgsPathCoordsState,
        removeRequiredHoleAreaPolygon,
        removeRequiredSiteAreaPolygon,
        addListenersOnEditAreaFinalPolygon,
        addListenersOnEditSiteAreaChangesPolygon,
        addListenersOnEditSiteAreaFinalPolygon,
        updateClickedSiteAreaPolygon,
        updateClickedHoleAreaPolygon,
        teesZoneDisplayed,
        fwysZoneDisplayed,
        gmsZoneDisplayed,
        extsZoneDisplayed,
        stgsZoneDisplayed,
) =>{
    let tempHoleArea = siteSetupState[0].HoleAreas?.find((item) => item.Id === indexId);

    removeRequiredHoleAreaPolygon();

    if(tempHoleArea?.Type === 0){
      let tempIndex = teesAreaPathState.findIndex((el) => el.Id === indexId)
      let zone =
        mapsData &&
        new mapsData.Polygon({
          paths: teesPathCoordsState[tempIndex],
          strokeColor: "#eb0c0a",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#eb0c0a",
          fillOpacity: 0.15,
          indexID: indexId,
          zIndex: 2,
        });

      zone.setMap(mapData);
      addListenersOnEditAreaFinalPolygon(zone);
      teesZoneDisplayed.push(zone);

    } else if(tempHoleArea?.Type === 1){
      let tempIndex = fwysAreaPathState.findIndex((el) => el.Id === indexId)
      let zone =
        mapsData &&
        new mapsData.Polygon({
          paths: fwysPathCoordsState[tempIndex],
          strokeColor: "#f0f004",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#f0f004",
          fillOpacity: 0.15,
          indexID: indexId,
          zIndex: 2,
        });

      zone.setMap(mapData);
      addListenersOnEditAreaFinalPolygon(zone);
      fwysZoneDisplayed.push(zone);

    } else if(tempHoleArea?.Type === 2){
      let tempIndex = gmsAreaPathState.findIndex((el) => el.Id === indexId)
      let zone =
        mapsData &&
        new mapsData.Polygon({
          paths: gmsPathCoordsState[tempIndex],
          strokeColor: "#067c05",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#067c05",
          fillOpacity: 0.15,
          indexID: indexId,
          zIndex: 2,
        });

      zone.setMap(mapData);
      addListenersOnEditAreaFinalPolygon(zone);
      gmsZoneDisplayed.push(zone);

    } else if(tempHoleArea?.Type === 3){
      let tempIndex = extsAreaPathState.findIndex((el) => el.Id === indexId)
      let zone =
        mapsData &&
        new mapsData.Polygon({
          paths: extsPathCoordsState[tempIndex],
          strokeColor: "#0202f2",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#0202f2",
          fillOpacity: 0.15,
          indexID: indexId,
          zIndex: 2,
        });

      zone.setMap(mapData);
      addListenersOnEditAreaFinalPolygon(zone);
      extsZoneDisplayed.push(zone);
    }else{
      removeRequiredSiteAreaPolygon()
      let tempSiteArea = siteSetupState[0].SiteAreas?.find(
        (item) => item.Id === TempSiteData[0].Id
        );
      if(tempSiteArea.Type === 0){
        let tempIndex = stgsAreaPathState.findIndex((el) => el.Id === TempSiteData[0].Id)
        let zone =
          mapsData &&
          new mapsData.Polygon({
            paths: stgsPathCoordsState[tempIndex],
            strokeColor: "#663a83",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#663a83",
            fillOpacity: 0.15,
            indexID: TempSiteData[0].Id,
            zIndex: 2,
          });
  
        zone.setMap(mapData);
        addListenersOnEditSiteAreaChangesPolygon(zone);
        addListenersOnEditSiteAreaFinalPolygon(zone);
        stgsZoneDisplayed.push(zone);
      }
    }
    if(isSiteAreaPolygon){
      updateClickedSiteAreaPolygon(siteAreaClickEventData, siteAreaClickEvent)
    }else if(isHoleeAreaPolygon){
      updateClickedHoleAreaPolygon(siteAreaClickEventData, siteAreaClickEvent)
    }
}